import MemberBenefits from './member-benefits'

export default MemberBenefits
